import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { useServicesContext } from '../../../../../context';
import { dynamicStylingHelper } from '../../../../utils';
import { renderSelectField, renderHiddenField, renderRadioField as renderRadioFields, RenderTextField, } from './form-fieldsRethink';
import { InfoIcon } from './InfoIcon';
import { FormElementWrapper, FormColumnWrapper } from './financeModal-stylesRethink';
export const FinanceFormWrapper = ({ formData, inputFields, setFormValue, calculate, loading, }) => {
    var _a;
    if (!formData) {
        return null;
    }
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const { fields } = audiContentService.getContent();
    const { shiftCurrencySymbolLeftToRight } = fields;
    return (React.createElement(FormColumnWrapper, null, (_a = formData === null || formData === void 0 ? void 0 : formData.data) === null || _a === void 0 ? void 0 : _a.map((form) => (React.createElement(React.Fragment, { key: `input-map-wrappper${form.name}` }, form.parameter
        .filter((field) => field.control.type !== 'Label')
        .map((field) => (React.createElement(FormElementWrapper, { key: `input-${field.id}` },
        field.control.type === 'Select' && (React.createElement(React.Fragment, { key: `seperate-breakdown-fields-${form.label}` }, field.control.style === 'Radio'
            ? renderRadioFields(field, form.name, inputFields, setFormValue, calculate, loading)
            : renderSelectField(field, form.name, inputFields, setFormValue, calculate, loading, trackingService))),
        field.control.type === 'Hidden' &&
            renderHiddenField(field, form.name, inputFields),
        field.control.type === 'Edit' && (React.createElement(RenderTextField, { field: field, formName: form.name, inputFields: inputFields, setFormValue: setFormValue, calculate: calculate, loading: loading, shiftCurrencySymbolLeftToRight: shiftCurrencySymbolLeftToRight })),
        React.createElement(InfoIcon, { key: `form-icon-button${field.id}`, hideButton: !field.hasHelp && field.control.type !== 'Label', popupContent: field.help, iconSize: dynamicStylingHelper('md', 'xs'), ariaLabel: useI18n({
                id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${field.id}`,
                defaultMessage: `${field.id}`,
            }) })))))))));
};
